export default "__VITE_ASSET__rAcaVMWl__"